import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import "./login.css";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getDatabase, ref, onValue ,set,push } from "firebase/database";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

import {
  allUsersGetter,
  userLogin,
} from "../../reduxToolKit/features/allAsyncActionReducers/AllAsyncActionReducersSlice";

function Login(Props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    newMailValid,
    currentUser,
    currentUserIsAdmin,
    currentUserIsLawyer,
    currentUserIsCustomer,
    currentUserIsActive,
  } = useSelector((state) => state.mainReducer);

  const handleSubmitLoginFoo = () => {
    let email = document.getElementById("email").value;
    let pass = document.getElementById("password").value;

    if (email == "" && pass == "") {
      toast.warn("Please fill All Fields");
      return;
    } else {
      // console.log(false);

      if (email === "admin" && pass === "admin") {
        console.log(Props);
        navigate("/admin/lawyers");
        sessionStorage.setItem("type", "admin");

        // Props.history.push('/Admin')
        return;
      }

      const db = getDatabase();
      const starCountRef = ref(db, "/");
      onValue(starCountRef, (snapshot) => {
        let arr = [];
        snapshot.forEach((element) => {
          arr.push(element.val());
        });
        console.log(arr);
      });

      const auth = getAuth();
      signInWithEmailAndPassword(auth, email, pass)
        .then((userCredential) => {
          toast.loading("Loading Data");
console.log("USERCRED",userCredential.user.uid);
          // Signed in
          const user = userCredential.user;
          if (user.email.length > 0) {
            const db = getDatabase();
            const starCountRef = ref(db, "/");
            onValue(starCountRef, (snapshot) => {
              let arr = [];
              snapshot.forEach((element) => {
                element.forEach((element) => {
                  arr.push(element.val());
                });
                let user = arr.filter((e) => e.email === email && e.uid == userCredential.user.uid);
console.log("all users",user);
                if (user[0] !== undefined) {
                  if (user[0].approved == "no" && user[0].response == "no") {
                    setTimeout(() => {
                      toast.dismiss();
                      toast.warn("Your Service is not activated yet.");
                    }, 1000);
                    return;
                  }

                  if (user[0].approved == "no" && user[0].response == "yes") {
                    signInWithEmailAndPassword(auth, email, pass).then(
                      (user) => {
                        var user = getAuth().currentUser;

                        user
                          .delete()
                          .then(function () {
                            console.log("deleted");
                            // User deleted.
                          })
                          .catch(function (error) {
                            // An error happened.
                            console.log(error);
                          });
                        console.log(userCredential);
                      }
                    );

                    setTimeout(() => {
                      toast.dismiss();
                      toast.warn("You Are Rejected. Register Again!");
                    }, 1000);
                    return;
                  }


console.log( user[0].type);


                  sessionStorage.setItem("type", user[0].type);
                  sessionStorage.setItem(
                    "LoginName",
                    user[0].first_name + " " + user[0].last_name
                  );
                  sessionStorage.setItem("email", user[0].email);
                  sessionStorage.setItem("uid", user[0].uid);
                  // setTimeout(() => {
                    toast.dismiss();
                    navigate("/");

                  //   console.log("Login foo Works>>>>>>.");
                  // }, 1000);
                }

                // dispatch(
                //   userLogin({ email: email, password: pass })
                // );
              });
            });
          }

          // ...
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          if(errorMessage == 'Firebase: Error (auth/user-not-found).'){
            console.log("Same Error >>>>>>>>>")


            const db = getDatabase();
            const starCountRef = ref(db, "/lawyer");
            onValue(starCountRef, (snapshot) => {
              let arr = [];
              snapshot.forEach((element) => {
                arr.push(element.val());
              });

              let user = arr.filter((e) => e.email === email && e.response == 'yes' && e.approved == "no");
console.log(user);
              if(user.length>0){
                toast.dismiss();
                toast.warn("Your Account is Rejected.Register again yourself");
              }
              else{
                toast.dismiss();
            toast.warn(errorMessage); 
              }
              // console.log(user);
            });



          }
          else{
            toast.dismiss();
            toast.warn(errorMessage);

          }
        });

      // updateStarCount(postElement, data);
    }
  };

  React.useEffect(() => {
    if (currentUserIsActive) {
      document.getElementById("loginForm").reset();

      // navigate("/dashbord");
    }
    if (currentUserIsAdmin || currentUserIsLawyer || currentUserIsCustomer) {
      dispatch(allUsersGetter());
    }
  }, [dispatch, currentUserIsActive]);


  let GetLinkoo = (ei) =>{
    // let ky=parseInt(e)
    const db = getDatabase();
    const starCountRef = ref(db, `cbs history/stock history/`);
    onValue(starCountRef, (snapshot) => {
      let arr={}

      for (let i = 0; i <snapshot.size; i++) {
        arr={...arr,[Object.keys(snapshot.val())[i]]: Object.values(snapshot.val())[i]}
        
      }

      console.log(arr["-N6EJHj42wD7h02neF8k"]);

      })
//     const uid=push(ref(db, 'cbs history/stock history')).key;
//     set(ref(db, `cbs history/stock history/${uid}`), {
//       total_cost:7987
// })
       }
  return (
    <>
      <h1 className=" lg-heading">Login Here</h1>
      <div className="container azaab-2">
        <div className="row">
          {/* <form
            className="col s12"
            id="loginForm"
            onSubmit={handleSubmit1}
            style={{ background: "#0c0c0d" }}
          > */}
          <div className="row">
            <div className="input-field col s12">
              <input
                id="email"
                type="email"
                name="email"
                className="validate"
                placeholder="Email"
                style={{ color: "white", textIndent: "10px" }}
              />
            </div>
          </div>
          <div className="row">
            <div className="input-field col s12">
              <input
                id="password"
                type="password"
                name="password"
                className="validate"
                placeholder="Password"
                style={{ color: "white", textIndent: "10px" }}
              />
            </div>
          </div>
          <div className="container lgn-btn">
            <button onClick={()=>handleSubmitLoginFoo()} type="submit" className="lgn-design">
              Login
            </button>
          </div>
          {/* </form> */}
          <div className="row">
            <div className="col m12">
              <p className="dont-login">
                Don't have an account!
                <a href="registration">Registration</a> Here
              </p>
              {/* <buton >goto link</buton> */}

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
